import React from 'react';

interface IProps {}

const FormItemOptional: React.FC<IProps> = () => <span className="ml-1 opacity-60">(optional)</span>;
export default FormItemOptional;
